<template>
  <div class="page page-cars">
    <h3>Автомобиль</h3>
    <ActionBar
      :isEditing="isEditing"
      @changeAction="changeCar"
      @cancelAction="cancelCarChanges"
      @deleteAction="deleteCar"
      @saveAction="updateCar"
    />
    <br/>
    <CarEditForm v-if="isEditing" :car="car" :trackingDevicesList="trackingDevicesList" />
    <CarShowForm v-else :car="car" />
    <div class="car-equipments">
      <EquipmentsView
        :equipments="car.equipments"
        @actionEdit="$router.push(`/cars/${carId}/equipments`)"
      />
    </div>
    <hr class="mb-4" />
    <div class="car-docs">
      <h5>
        Документы
        <router-link :to="`/cars/${carId}/docs/create`" class="btn btn-primary add-doc">Добавить</router-link>
      </h5>
      <br />
      <LightBox
        v-if="showDetailImage"
        @actionClose="showDetailImage = false"
        :scan="currentScan"
      />
      <Document
        v-for="document of car.documents"
        :key="document.id"
        :viewComponent="DocumentTypes[document.type].viewComponent"
        :title="DocumentTypes[document.type].title"
        :scansTitle="DocumentTypes[document.type].tabs.scansTittle"
        :document="document"
        @actionDetailImage="detailImage(currentScan)"
        @actionDelte="deleteDocument(document.id)"
        @actionUpdate="$router.push(`/cars/${carId}/docs/${document.id}/update`)"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */

import Swal from 'sweetalert2'
import CarsAPI from '@/api/cars'
import deepAssign from 'assign-deep'
import DocumentTypes from '@/views/carDocuments/types'
import DocumentsAPI from '@/api/car-documents'
import { mapMutations, mapActions } from 'vuex'

export default {
  name: 'CarPage',
  props: ['carId'],
  data () {
    return {
      isUpdating: false,
      car: {
        brand: '',
        model: '',
        registration_plate: '',
        manufacturing_year: '',
        radio_code: '',
        data: ''
      },
      trackingDevicesList: [],
      showDetailImage: false,
      DocumentTypes,
      isEditing: false,
      prevCar: null,
      currentScan: null
    }
  },
  mounted () {
    this.loadData()
    this.loadDeviceItems().then(result => {
      this.trackingDevicesList = result
    })
  },
  methods: {
    loadData () {
      CarsAPI.getItem({
        id: this.carId,
        queryWith: ['documents', 'isServe', 'equipments', 'trackingDevice']
      })
        .then(response => {
          this.car = response
          this.loadScans()
        })
    },
    loadScans () {
      this.clearItems()
      this.setModel('CarDocument')
      this.car.documents.forEach(element => {
        DocumentsAPI.getScans(element.id).then(result => {
          element.scans = result
          this.pushItems({ scans: result, documentId: element.id })
        })
          .catch(text => {
            Swal.fire({
              icon: 'error',
              title: 'Ошибка',
              text: text.message
            })
          })
      })
    },
    changeCar () {
      this.prevCar = deepAssign({}, this.car)
      this.isEditing = true
    },
    deleteCar () {
      Swal.fire({
        icon: 'warning',
        title: 'Вы действительно хотите удалить автомобиль?',
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonColor: '#c82333',
        cancelButtonText: 'Отменить',
        confirmButtonText: 'Удалить'
      }).then(event => {
        if (event.value) {
          CarsAPI.removeItem(this.carId)
            .then(() => {
              this.$router.push('/cars')
            })
            .catch(text => {
              Swal.fire({
                icon: 'error',
                title: 'Ошибка',
                html: text.message
              })
            })
        }
      })
    },
    cancelCarChanges () {
      this.car = this.prevCar
      this.isEditing = false
    },
    updateCar () {
      if (this.isUpdating) {
        return
      }
      this.isUpdating = true
      CarsAPI.updateItem(this.car)
        .then(car => {
          this.car = { ...this.car, ...car.model }
          this.car.tracking_device_id = parseInt(this.car.tracking_device_id)
          this.car.trackingDevice = this.trackingDevicesList.find(e => {
            return e.id == this.car.tracking_device_id
          })
          this.isUpdating = false
          this.isEditing = false
        })
        .catch(text => {
          this.isUpdating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    },
    deleteDocument (documentId) {
      DocumentsAPI.removeItem(documentId)
        .then(() => this.loadData())
        .catch(text => {
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    },
    ...mapActions('taxi/trackDevices', {
      loadDeviceItems: 'loadItems'
    }),
    ...mapMutations('taxi/scans', [
      'pushItems',
      'clearItems',
      'setModel'
    ])
  }
}
</script>

<style scoped>
  .page-cars {
    width: 98%;
    padding-bottom: 4rem;
    padding-top: 2.5rem;
  }
  .add-doc {
    float: right;
  }
</style>
